module.exports = __webpack_public_path__ + "static/media/iconList2.901b3f12.svg";